<div class="header-container">
  <h5 style="margin-left: 5px;">{{ title }}</h5>
</div>



<div class="header-container">
  <div *ngIf="isUseQuickBook">
    <ngx-button *ngIf="isQuickBookExpired" status="danger" (click)="connect()">Reconnect to QuickBooks</ngx-button>
    <ngx-button *ngIf="!isQuickBookExpired && isResync" status="warning" (click)="resync()" [isLoading]="isLoading">Resync QuickBooks</ngx-button>
  </div>
  <nb-actions size="small">
    <nb-action class="user-action">
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.unique_name"
               [picture]="'assets/images/default-user-avatar.png'">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
